// src/components/ui/SessionTimeout.js

import React, { useState, useEffect } from 'react';
import SafeMCCDialog from './SafeMCCDialog';
import { useAuth } from '../../context/auth';
import useIdleTimer from '../../hooks/useIdleTimer';
import { Clock } from 'lucide-react';

const SessionTimeout = () => {
	const { logout } = useAuth();
	const [showModal, setShowModal] = useState(false);
	const [countdown, setCountdown] = useState(60);

	const handleIdle = () => {
		setShowModal(true);
	};

	const { resetTimer } = useIdleTimer(handleIdle, 120); // 120-second idle timer

	useEffect(() => {
		let interval;
		if (showModal) {
			interval = setInterval(() => {
				setCountdown(prev => {
					if (prev === 1) {
						clearInterval(interval);
						handleLogout();
						return 0;
					}
					return prev - 1;
				});
			}, 1000);
		}
		return () => clearInterval(interval);
	}, [showModal]);

	const handleStay = () => {
		setShowModal(false);
		setCountdown(60);
		resetTimer();
	};

	const handleLogout = () => {
		logout();
	};

	return (
		<SafeMCCDialog
			open={showModal}
			onClose={handleStay}
			title="Session Timeout"
			titleIcon={Clock}
			maxWidth="sm"
			buttons={[
				{
					label: 'Log Out',
					onClick: handleLogout,
					variant: 'text',
					color: 'secondary'
				},
				{
					label: 'Stay Signed In',
					onClick: handleStay,
					variant: 'contained',
					color: 'primary'
				}
			]}
		>
			<div>
				<p className="text-lg font-semibold mb-2">
					You will be logged out in <span className="text-blue-600">{countdown}</span> seconds due to inactivity.
				</p>
				<p className="text-gray-600">
					Do you want to stay signed in?
				</p>
			</div>
		</SafeMCCDialog>
	);
};

export default SessionTimeout;
